module.exports = __webpack_public_path__ + "img/kw.496fa466.svg";